import { reducer } from './modules';

export { default as procedureActions } from './modules';
export { default as procedureSaga } from './sagas';
export { default as procedureSelectors } from './selectors';
export { default as procedureOperations } from './operations';

export default reducer;
